import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Input as InputAppkit } from '@pwc/appkit-react/lib/Input';

const Input = ({ onChange, name, type, ...props }) => {
  const onChangeHandler = useCallback(value => {
    if (onChange) {
      onChange({ target: { value, name, type } });
    }
  }, [onChange, name, type]);

  return (
    <InputAppkit {...props} type={type} name={name} onChange={onChangeHandler}/>
  );
};

Input.defaultProps = {
  className: '',
  value: '',
  type: 'text',
};

Input.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
};

export default Input;
